export default __webpack_public_path__ + "static/media/tours.22b767c6.jpg";